exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content{\n    box-shadow: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/evs/guarantee/guarantee-add.component.css
// module id = ../../../../../src/app/pages/admin/evs/guarantee/guarantee-add.component.css
// module chunks = 3